module.exports = __webpack_public_path__ + "img/wallet.bed8405d.png";